// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i2huF","type":"styles_type__3V5mY","choices":"styles_choices__2LDlh"};